import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalContext } from "../context/context";
import AuthShell from "./AuthShell";

const Login = () => {
  const navigate = useNavigate();
  const { baseUrl, getUser } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { handleSubmit, register, formState: { errors } } = useForm();

  const storeuserPassword = (userpass, id, token) => {
    axios.put(baseUrl + "users/updatedata/" + id, { userpass }, { headers: { token } })
      .then(() => {})
      .catch(() => {});
  };

  const getLoginDetails = (formData) => {
    setLoading(true);
    axios.post(baseUrl + "auth/login", formData)
      .then((response) => {
        if (response.status === 200) {
          storeuserPassword(formData.password, response.data._id, response.data.accessToken);
          sessionStorage.setItem("user", JSON.stringify(response.data));
          sessionStorage.setItem("accessToken", JSON.stringify(response.data.accessToken));
          getUser(response.data.accessToken, response.data._id);
          navigate("/wallet");
        }
      })
      .catch((error) => {
        if (error?.response?.data === "Wrong credentials") toast.error("Email or password is incorrect");
        else toast.error("We could not sign you in. Please try again.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <AuthShell
      variant="login"
      title="Welcome back"
      description="Sign in to continue to your ProfitGrowing account."
      footer={<p>New to ProfitGrowing? <Link to="/auth/register">Create an account</Link></p>}
    >
      <form className="auth-form" onSubmit={handleSubmit(getLoginDetails)} noValidate>
        <label className="auth-field" htmlFor="login-email">Email address
          <input id="login-email" type="email" autoComplete="email" placeholder="you@example.com" aria-invalid={Boolean(errors.email)} {...register("email", { required: "Email is required" })} />
          {errors.email ? <span className="auth-error">{errors.email.message}</span> : null}
        </label>
        <div className="auth-field">
          <label htmlFor="login-password">Password</label>
          <span className="auth-password-control">
            <input id="login-password" type={passwordVisible ? "text" : "password"} autoComplete="current-password" placeholder="Enter your password" aria-invalid={Boolean(errors.password)} {...register("password", { required: "Password is required" })} />
            <button className="auth-password-toggle" type="button" aria-label={passwordVisible ? "Hide password" : "Show password"} onClick={() => setPasswordVisible((visible) => !visible)}>{passwordVisible ? <MdVisibilityOff aria-hidden="true" /> : <MdVisibility aria-hidden="true" />}</button>
          </span>
          {errors.password ? <span className="auth-error">{errors.password.message}</span> : null}
        </div>
        <div className="auth-inline-link"><Link to="/auth/forget">Forgot password?</Link></div>
        <button className="auth-submit" type="submit" disabled={loading}>{loading ? "Signing you in…" : "Sign in"}<span aria-hidden="true">→</span></button>
      </form>
      <ToastContainer position="top-right" newestOnTop />
    </AuthShell>
  );
};

export default Login;
